var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.$store.state.query.view == 'SendMessage'
      ? 'background-color: #c4261b'
      : '')},[_c('v-main',{staticClass:"change-font"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }